<template>
    <section>
        <div class="grid fixed xs-grid-cols-1 gap-2 home-nearbyviewed">
            <div class="text-center">
                <h2 class="f2 text-bold">
                    {{molang('home.RecentDesp')}}
                </h2>
            </div>
            <mvtNearby type="viewed" carousalType="viewed"></mvtNearby>
        </div>
    </section>
</template>

<script src="./home-nearbyviewed.js"></script>

<style lang="scss">
.home-nearbyviewed {
    .mvt-shifter .arrow.next{
        background-image: linear-gradient(90deg, transparent 0, var(--color-bg-l1) 40%);
    }
    .mvt-shifter .arrow.prev{
        background-image: linear-gradient(270deg, transparent 0, var(--color-bg-l1) 40%);
    }
}
</style>